import React from 'react';

/**
 * Reusable Clippy SVG component - used across all displays
 */
const ClippySVG = ({ size = 100, animated = true }) => {
  return (
    <div style={{ width: size, height: size * 1.3 }}>
      <svg viewBox="0 0 100 130" style={{ width: '100%', height: '100%' }}>
        {animated && (
          <style>{`
            .clippy-body { 
              animation: clippyFloat 3s ease-in-out infinite; 
              transform-origin: center center;
            }
            .clippy-arm-left {
              animation: clippyArmLeft 2s ease-in-out infinite;
              transform-origin: 27px 55px;
            }
            .clippy-arm-right {
              animation: clippyArmRight 2s ease-in-out infinite;
              transform-origin: 73px 55px;
            }
            .clippy-eyes {
              animation: clippyBlink 4s ease-in-out infinite;
            }
            @keyframes clippyFloat {
              0%, 100% { transform: translateY(0); }
              50% { transform: translateY(-5px); }
            }
            @keyframes clippyArmLeft {
              0%, 100% { transform: rotate(0deg); }
              50% { transform: rotate(-8deg); }
            }
            @keyframes clippyArmRight {
              0%, 100% { transform: rotate(0deg); }
              50% { transform: rotate(8deg); }
            }
            @keyframes clippyBlink {
              0%, 45%, 55%, 100% { transform: scaleY(1); }
              50% { transform: scaleY(0.1); }
            }
          `}</style>
        )}
        
        <g className={animated ? "clippy-body" : ""}>
          {/* Shadow */}
          <ellipse cx="50" cy="122" rx="20" ry="4" fill="rgba(0,0,0,0.2)" />
          
          {/* Paperclip Base */}
          <path d="M 42 70 L 42 110 Q 42 118 50 118 Q 58 118 58 110 L 58 70" 
                fill="none" stroke="#6B7280" strokeWidth="8" strokeLinecap="round"/>
          
          {/* Body */}
          <rect x="25" y="45" width="50" height="40" rx="8" fill="#F59E0B" stroke="#1F2937" strokeWidth="2" />
          
          {/* Chest Plate */}
          <rect x="32" y="52" width="36" height="22" rx="4" fill="#6B7280" stroke="#1F2937" strokeWidth="1.5" />
          <rect x="36" y="57" width="12" height="12" rx="2" fill="#4B5563" />
          <rect x="52" y="57" width="12" height="12" rx="2" fill="#4B5563" />
          
          {/* Left Arm */}
          <g className={animated ? "clippy-arm-left" : ""}>
            <rect x="5" y="50" width="22" height="18" rx="4" fill="#F59E0B" stroke="#1F2937" strokeWidth="1.5" />
            <text x="16" y="62" fontSize="6" fill="#1F2937" textAnchor="middle" fontWeight="bold">GVC</text>
            <rect x="3" y="66" width="14" height="10" rx="3" fill="#4B5563" stroke="#1F2937" strokeWidth="1" />
          </g>
          
          {/* Right Arm */}
          <g className={animated ? "clippy-arm-right" : ""}>
            <rect x="73" y="50" width="22" height="18" rx="4" fill="#F59E0B" stroke="#1F2937" strokeWidth="1.5" />
            <text x="84" y="62" fontSize="6" fill="#1F2937" textAnchor="middle" fontWeight="bold">GVC</text>
            <rect x="83" y="66" width="14" height="10" rx="3" fill="#4B5563" stroke="#1F2937" strokeWidth="1" />
          </g>
          
          {/* Head */}
          <rect x="28" y="12" width="44" height="35" rx="8" fill="#6B7280" stroke="#1F2937" strokeWidth="2" />
          
          {/* Helmet Top */}
          <rect x="35" y="2" width="30" height="12" rx="4" fill="#F59E0B" stroke="#1F2937" strokeWidth="1.5" />
          
          {/* Antenna */}
          <path d="M 50 2 Q 50 -5 55 -5 Q 60 -5 60 0" fill="none" stroke="#6B7280" strokeWidth="3" strokeLinecap="round" />
          
          {/* Ears */}
          <polygon points="22,22 28,15 28,30" fill="#F59E0B" stroke="#1F2937" strokeWidth="1.5" />
          <polygon points="78,22 72,15 72,30" fill="#F59E0B" stroke="#1F2937" strokeWidth="1.5" />
          
          {/* Eyes */}
          <g className={animated ? "clippy-eyes" : ""}>
            <ellipse cx="40" cy="26" rx="7" ry="9" fill="white" stroke="#1F2937" strokeWidth="1.5" />
            <ellipse cx="60" cy="26" rx="7" ry="9" fill="white" stroke="#1F2937" strokeWidth="1.5" />
            <ellipse cx="41" cy="27" rx="3" ry="4" fill="#1F2937" />
            <ellipse cx="61" cy="27" rx="3" ry="4" fill="#1F2937" />
            <circle cx="39" cy="24" r="2" fill="white" />
            <circle cx="59" cy="24" r="2" fill="white" />
          </g>
          
          {/* Eyebrows */}
          <path d="M 33 18 Q 40 15 47 18" fill="none" stroke="#1F2937" strokeWidth="2" strokeLinecap="round" />
          <path d="M 53 18 Q 60 15 67 18" fill="none" stroke="#1F2937" strokeWidth="2" strokeLinecap="round" />
          
          {/* Mouth - Smile */}
          <path d="M 40 36 Q 50 42 60 36" fill="none" stroke="#1F2937" strokeWidth="2.5" strokeLinecap="round" />
        </g>
      </svg>
    </div>
  );
};

export default ClippySVG;
